import { Box, useTheme } from '@mui/material';
import { Small } from '../../components/Typography';

const ToggleButton = ({ tabs, activeTab, setActiveTab }) => {
  const theme = useTheme();

  return (
    <Box pr={0.5}>
      <Box
        sx={{
          display: 'flex',
          backgroundColor: theme.palette.primary.grey10,
          borderRadius: '25px',
          padding: '6px',
          cursor: 'pointer',
          width: '100%',
        }}
      >
        {tabs.map(tab => (
          <Box
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              backgroundColor: activeTab === tab.id ? '#4F7EFF' : 'transparent',
              borderRadius: '23px',
              padding: '6px 16px',
              flex: 1,
              transition: 'all 0.2s ease',
              cursor: 'pointer',
            }}
          >
            <Small
              sx={{
                whiteSpace: 'nowrap',
                color: activeTab === tab.id ? '#ffffff' : '#999999',
                fontWeight: activeTab === tab.id ? 600 : 500,
              }}
            >
              {tab.label}
            </Small>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default ToggleButton;
